export default "__VITE_ASSET__DE0Wp4Oa__"